//
//
//
//
//
//
//
//

import IM, { IM_STORE } from '@/data/im'
const KEY = 'unread'
export default {
    options: {
        virtualHost: true
    },
    data () {
        return {
            show_unread: false
        }
    },
    onPageShow () {
        IM.checkUnread()
    },
    mounted () {
        IM_STORE.add_show_unread_watcher(KEY, show_unread => {
            this.show_unread = show_unread
        })
    },
    destroyed () {
        IM_STORE.remove_show_unread_watcher(KEY)
    }
}
